import { render, staticRenderFns } from "./AddressBookTable.vue?vue&type=template&id=ba66da16"
import script from "./AddressBookTable.vue?vue&type=script&lang=ts"
export * from "./AddressBookTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports